const testimonials = [
  {
    name: "Sarah M.",
    location: "Grand Rapids, MI",
    rating: 5,
    text: "BoxFreeMove was a total game changer for our move across town. No tape, no cardboard mess, no trips to the recycling center. The totes showed up clean and sturdy — I honestly don't know why anyone still uses cardboard boxes.",
    avatar: "https://public.readdy.ai/ai/img_res/f7a2e1e0d51104d16d8590f76f7a7eae.jpg",
    tag: "Homeowner"
  },
  {
    name: "Jake T.",
    location: "Kentwood, MI",
    rating: 5,
    text: "I've moved four times in the last six years and this was by far the easiest. Drop-off was on time, the totes stacked perfectly in the moving truck, and pickup was just as smooth. Highly recommend to anyone in the Grand Rapids area.",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20late%20twenties%20casual%20headshot%20natural%20light%20warm%20neutral%20background%20relaxed%20confident%20expression&width=100&height=100&seq=avatar-jake-001&orientation=squarish",
    tag: "Repeat Customer"
  },
  {
    name: "Lindsey & Tom R.",
    location: "Rockford, MI",
    rating: 5,
    text: "We were skeptical at first but wow — these totes are so much better than boxes. They're sturdy, they stack, and the lids actually stay on. Pickup was fast and the whole experience felt premium. Worth every penny.",
    avatar: "https://readdy.ai/api/search-image?query=happy%20couple%20smiling%20casual%20photo%20warm%20natural%20light%20neutral%20background%20friendly%20approachable%20expression&width=100&height=100&seq=avatar-couple-001&orientation=squarish",
    tag: "Family Move"
  },
  {
    name: "Marcus D.",
    location: "Wyoming, MI",
    rating: 5,
    text: "As someone who cares about the environment, I love that I'm not throwing away a mountain of cardboard after every move. The totes are clean, durable, and the service was super professional. This is the future of moving.",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20early%20forties%20professional%20casual%20headshot%20warm%20light%20neutral%20background%20confident%20relaxed%20expression&width=100&height=100&seq=avatar-marcus-001&orientation=squarish",
    tag: "Eco-Conscious Mover"
  },
  {
    name: "Brittany H.",
    location: "Grandville, MI",
    rating: 5,
    text: "I was moving solo and the last thing I needed was to deal with buying boxes and tape. BoxFreeMove made it so simple — I booked online, they delivered, I packed, they picked up. Done. Stress-free move accomplished!",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20woman%20late%20twenties%20casual%20headshot%20warm%20natural%20light%20neutral%20background%20happy%20relaxed%20expression&width=100&height=100&seq=avatar-brittany-001&orientation=squarish",
    tag: "Solo Mover"
  },
  {
    name: "Chris & Dana W.",
    location: "Caledonia, MI",
    rating: 5,
    text: "We moved from Caledonia to Ada and used BoxFreeMove for the whole thing. The totes held everything from dishes to clothes to books without a single issue. Delivery and pickup were both right on schedule. 10/10 would use again.",
    avatar: "https://readdy.ai/api/search-image?query=happy%20smiling%20couple%20forties%20casual%20warm%20natural%20light%20neutral%20background%20friendly%20approachable%20relaxed%20expression&width=100&height=100&seq=avatar-chris-001&orientation=squarish",
    tag: "Local Move"
  }
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="w-4 h-4 flex items-center justify-center">
          <i className="ri-star-fill text-yellow-400 text-sm"></i>
        </div>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="py-24 bg-gray-50" id="testimonials">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-yellow-400 text-gray-900 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4">
            Real Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            West Michigan Movers Love Us
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Don't take our word for it — here's what your neighbors across Grand Rapids and surrounding communities are saying.
          </p>

          {/* Aggregate rating bar */}
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                </div>
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">5.0</span>
            <span className="text-gray-400 text-sm">· 100% 5-star reviews</span>
          </div>
        </div>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 flex flex-col"
            >
              {/* Quote icon */}
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-yellow-400 text-3xl"></i>
              </div>

              {/* Review text */}
              <p className="text-gray-700 text-sm leading-relaxed flex-1 mb-6">
                "{t.text}"
              </p>

              {/* Footer */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-gray-900 text-sm">{t.name}</span>
                    <span className="bg-yellow-100 text-yellow-700 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">{t.tag}</span>
                  </div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <StarRating count={t.rating} />
                    <span className="text-gray-400 text-xs">{t.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom trust badge */}
        <div className="mt-14 text-center">
          <div className="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-full px-6 py-3 shadow-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-fill text-yellow-400 text-lg"></i>
            </div>
            <span className="text-gray-700 text-sm font-medium">Proudly serving West Michigan — from Rockford to Plainwell, Allendale to Lowell</span>
          </div>
        </div>
      </div>
    </section>
  );
}
